import React from 'react';
import { requestAnimationFrameWithFallback } from '../SearchApp/utils';
import { HAS_WINDOW } from '@eb/feature-detection';
import { MOBILE_BREAKPOINT } from '../SearchApp/constants';

const getEDSNotificationHeight = () => {
    const headerEl = document.getElementsByClassName('eds-notification-bar')[0];

    if (headerEl) {
        return headerEl.getBoundingClientRect().height;
    }

    return 0;
};

// This class is mainly for dealing with this issue: https://github.com/eventbrite/eb-spa/pull/803
// Which happens because the cookie notification normally is not position: fixed,
// but in our Search UI we want the header to be fixed.
const withCookieHeaderHeight = (Component) =>
    class WithCookieHeaderHeightWrapper extends Component {
        state = {
            cookieHeaderHeight: null,
        };

        componentDidMount() {
            this._isMounted = true;

            if (HAS_WINDOW) {
                const hasNotificationBar =
                    document.getElementsByClassName('eds-notification-bar')
                        .length > 0;

                if (hasNotificationBar) {
                    const mediaQuery = window.matchMedia(
                        `(min-width: ${MOBILE_BREAKPOINT})`,
                    );

                    if (
                        mediaQuery.matches &&
                        !document.getElementById('withCookieHeaderHeightStyle')
                    ) {
                        document.head.insertAdjacentHTML(
                            'beforeend',
                            '<style id="withCookieHeaderHeightStyle">.eds-notification-bar{position:fixed}</style>',
                        );
                    }
                }
            }

            this.setCookieHeaderHeight();
        }

        componentWillUnmount() {
            this._isMounted = false;
            const cookieHeaderStyle = document.getElementById(
                'withCookieHeaderHeightStyle',
            );

            // We want to remove the style override if this component unmounts, for example
            // if going from the Search to the Homepage which have different headers.
            if (cookieHeaderStyle) {
                cookieHeaderStyle.parentNode.removeChild(cookieHeaderStyle);
            }
        }

        setCookieHeaderHeight = () => {
            if (this._isMounted) {
                this.setState({
                    cookieHeaderHeight: getEDSNotificationHeight(),
                });

                requestAnimationFrameWithFallback(this.setCookieHeaderHeight);
            }
        };

        render() {
            return (
                <Component
                    {...this.props}
                    cookieHeaderHeight={this.state.cookieHeaderHeight}
                />
            );
        }
    };

export default withCookieHeaderHeight;
